/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningBIcon20Light = forwardRef('NatureFxLightningBIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.207 1.614C10.788.856 12 1.267 12 2.223V8h3.736a1 1 0 0 1 .793 1.608l-6.736 8.778c-.581.758-1.793.346-1.793-.61V12H4.264a1 1 0 0 1-.793-1.61l6.736-8.776Zm.793.609L4.264 11H8a1 1 0 0 1 1 1v5.777L15.736 9H12a1 1 0 0 1-1-1V2.223Z" })));
});
